<template>
  <div style="width: 100%;height: 100%;overflow: hidden !important;position: absolute;">
    <div style="width: 100%;height: 100vh;overflow-y: scroll;padding-bottom: 100px;">
      <div style="height: 80px;width: 100%;margin: auto;line-height: 60px;background: #fff;padding: 10px;">
        <el-row>
          <el-col :span="12">
            <span class="text-gradient4" style="font-size: 20px;">预警工作台</span>
          </el-col>
          <el-col :span="12" style="text-align: right">
            <el-row style="float: right;">
              <img :src="defaultHeaderImgSrc" style="width: 60px;float: left;">
              <div style="float: left;">
                <div style="line-height: 30px">{{ session.userName }}</div>
                <div style="line-height: 30px">{{ session.mobile }}</div>
              </div>
            </el-row>
          </el-col>
        </el-row>
      </div>
      <div style="width: 100%;height: 80px;background: #f0f0f0;"></div>
      <div style="width: 98%;margin: 0 auto;background: #fff;padding-top: 30px;">
        <el-row>
          <div style="width: 49%;float: left;">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span style="font-size: 20px;" class="text-gradient2">预警消息</span>
              </div>
              <div class="text item">
                <div style="border-bottom: 3px solid #f0f0f0;">
                  <el-row>
                    <el-col :span="6" v-for="(itemIn, index) in msgAmountInfo" :name="'' + index" :key="index">
                      <span :class="activeName == index ? 'active' : ''" style="font-size: 17px;cursor: pointer" @click="turnList(index)">{{ itemIn.statusName }}（{{ itemIn.amount }}）</span>
                    </el-col>
                  </el-row>
                </div>
                <div>
                  <el-row v-for="item in list" :key="item.id" style="border-bottom: 1px solid #F5F5F5;" @click.native="toMsgDetail(item)">
                    <MsgItem ref="msgItem" :item="item" :role="role" @addCallbackReturn="handleToDetail"></MsgItem>
                  </el-row>
                </div>

              </div>
            </el-card>
          </div>

          <div style="margin-left: 2%;width: 49%;float:left;">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span style="font-size: 20px;" class="text-gradient1">预警任务</span>
                <span style="float: right;font-size: 16px;">
                <el-badge :value="taskNum" class="item">
                  <el-button size="small" @click="toTaskList">预警任务单</el-button>
                </el-badge>
              </span>
              </div>
              <div class="text item">
                <div style="border-bottom: 3px solid #f0f0f0;">
                  <el-row>
                    <el-col :span="6" v-for="(itemIn, index) in taskAmountInfo" :name="'' + index" :key="index">
                      <span :class="activeNameA == index ? 'active' : ''" style="font-size: 17px;cursor: pointer" @click="turnTaskList(index)">{{ itemIn.statusName }}（{{ itemIn.amount }}）</span>
                    </el-col>
                  </el-row>
                </div>
                <div>
                  <el-row v-for="item in taskList" :key="item.id" class="f-z17 lh40" style="border-bottom: 1px solid #F5F5F5;">
                    <TaskItem ref="msgItem" :item="item" :role="role" :active="activeNameA"
					@addCallbackReturnTask="handleToTaskDetail" @addCallbackReturnView="handleToTaskAudit"></TaskItem>
                  </el-row>
                </div>
              </div>
            </el-card>
          </div>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import { default as AlarmOrderApi } from '@/api/alarm/order/AlarmOrderApi.js'
import {default as AuthUtil} from "../../../util/auth.js";
import AppConfig from "../../../config/app";
import {default as PermissionApi} from "@/api/smp/auth/Permission";
import defaultHeader from '@/assets/images/default-header.jpg';
import { default as commonIn } from '@/util/common'
import MsgItem from '../../../components/alarm/messageItem'
import TaskItem from '../../../components/alarm/taskItem'
export default {
  name: "messageList",
  components: {
    MsgItem, TaskItem
  },
  props: {
    role: {
      type: Number
    },
    page: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      list: [],
      taskList: [],
      activeName: 0,
      activeNameA: 0,
      msgAmountInfo: [],
      taskAmountInfo: [],
      taskNum: 0,
      buttonPriviledgeList: [],
      defaultHeaderImgSrc:defaultHeader,
    }
  },
  created() {
    this.getButtonPriviledge()
    this.getUserInfo()
  },
  mounted() {
    this.getMsgCountInfo()
    // this.getTaskMountInfo()
    this.getMsgList()
    // this.getTaskList()
    console.log(this.role)
  },
  beforeCreate() {
    document.querySelector('body').setAttribute('style', 'background:#F0F0F0;overflow: hidden !important;')
  },
  computed: {
    session(){
      let session= this.$store.getters['app/getSession'];
      if(!session)
        session={userName:'',mobile:''};
      return session;
    }
  },
  methods: {
	// 去审阅
	handleToTaskAudit(item) {
	  let type = 1
	  this.$emit("addCallbackTask", {formStatus:'task', item: item, type: type, return: 2, audit: 2})
	},  
    // 获取用户信息
    getUserInfo() {
      let that = this
      AlarmOrderApi.getUserInfo({userId: -1}).then(res => {
        console.log(res);
        res = res.data
        if (res.code == 200) {
          let userInfo = res.data
          if (userInfo.id != undefined && userInfo.id != null) {
            that.page.roleId = userInfo.id
            if (userInfo.id == 1 || userInfo.id == 2 || userInfo.id == 5  || userInfo.id == 7) {
              that.role = 2
            } else if (userInfo.id == 6) {
              that.role = 1
            } else if (userInfo.id == 3 || userInfo.id == 4) {
              that.role = 3
            } else {
              alert('暂无权限查看此页面')
              return false
            }
          } else {
            alert('暂无权限查看此页面')
            return false
          }
          console.log(that.role)
          that.getTaskMountInfo()
          that.getTaskList()
        }
      })
    },
    turnList(val) {
      this.activeName = val
      console.log(val)
      this.getMsgList()
    },
    turnTaskList(val) {
      this.activeNameA = val
      this.getTaskList()
    },
    handleToDetail(item) {
      console.log(item)
      // 计算阅读时长
      if (item.status != 1) {
        let today = new Date()
        let deal = new Date(item.createDate)
        let usedTime = (today - deal)
        console.log(usedTime)
        let dealDuration = Math.floor(usedTime/(3600*1000));
        let params = {
          taskId: item.id,
          status: 1,
          dealDuration: dealDuration.toFixed(2)
        }
        console.log(params)
        AlarmOrderApi.editAlarmOrderStatus(params).then(res => {
          console.log(res)
        })
      }

      this.$emit("addCallbackMsg", {formStatus:'msg', item: item})
    },
	handleToTaskDetail(item, type) {
		this.$emit("addCallbackTask", {formStatus:'task', item: item, type: type})
	},
	
    // 获取消息列表
    getMsgList() {
      let that = this
      let params = {
        status: this.activeName,
        taskType: 1
      }
      AlarmOrderApi.getMsgList(params).then(res => {
        console.log(res)
        res = res.data
        if (res.code == 200) {
          let listIn = res.data;
          listIn.map(item => {
            let createDate = item.createDate
            let dateArr = commonIn.getAlarmCycle({date: createDate, type: 1})
            console.log(dateArr)
            item.startDate = dateArr[0]
            item.endDate = dateArr[1]

            if (item.categoryName == '毛利率') {
              item.dataIn = (parseFloat(item.data) * 100).toFixed(1) + '%'
            } else {
              item.dataIn = item.data
            }
            if (item.dataSamePeriod != null) {
              if (item.categoryName == '毛利率') {
                item.tb = (parseFloat(item.data) - parseFloat(item.dataSamePeriod)) * 100;
              } else {
                item.tb = parseFloat(item.data) / parseFloat(item.dataSamePeriod) * 100 - 100;
              }

              item.fh = 1
              if (item.tb < 0) {
                item.tb = (0 - item.tb).toFixed(1)
                item.fh = 2
              } else {
                item.tb = (item.tb).toFixed(1)
                if (item.tb > 100) {
                  item.fh = 2
                }
              }
            } else {
              item.tb = 0;
            }

            if (item.targetValue != null) {
              let target = parseFloat(item.targetValue)
              item.fh1 = 1
              if (target < 0) {
                target = 0 - target
                item.fh1 = 2
              }
              console.log(target)
              item.ysjd = (target * 100).toFixed(1)
              item.ysjd = item.ysjd + '%'
            } else {
              item.ysjd = 0;
            }

          })
          console.log(listIn)
          that.list = listIn
        }
      })
    },
    // 获取预警消息统计
    getMsgCountInfo() {
      let that = this
      AlarmOrderApi.getMsgCountInfo().then(res => {
        console.log(res)
        res = res.data
        if (res.code == 200) {
          that.msgAmountInfo = res.data
        } else {
          alert(res.msg)
        }
      }).catch(error => {
        console.log(error)
        alert('系统错误！')
      })
    },
    // 获取预警任务统计
    getTaskMountInfo() {
      let that = this
      AlarmOrderApi.getTaskCountInfo({type: 1, role: this.role}).then(res => {
        console.log(res)
        res = res.data
        if (res.code == 200) {
          that.taskAmountInfo = res.data
          let num = 0
          let dataIn = res.data
          if (dataIn.length > 0) {
            dataIn.map(item => {
              if (item.amount) {
                num += item.amount
              }
            })
          }
          that.taskNum = num
        } else {
          alert(res.msg)
        }
      }).catch(error => {
        console.log(error)
        alert('系统错误！')
      })
    },
    // 获取预警任务列表
    getTaskList() {
      let that = this
      let params = {
        status: this.activeNameA,
        taskType: 2,
        role: this.role
      }
      AlarmOrderApi.getTaskList(params).then(res => {
        console.log(res)
        res = res.data
        if (res.code == 200) {
          let listIn = res.data
          if (listIn.length > 0) {
            listIn.map(item => {
              if (item.categoryName == '毛利率') {
                item.dataIn = (parseFloat(item.data) * 100).toFixed(1) + '%'
              } else {
                item.dataIn = item.data
              }
              item.overTime = item.overTime == null ? '' : commonIn.timeFormatSeconds(item.overTime)
              if (item.categoryName != '空铺') {
                if (item.dataSamePeriod != null) {
                  if (item.categoryName == '毛利率') {
                    item.tb = (parseFloat(item.data) - parseFloat(item.dataSamePeriod)) * 100;
                  } else {
                    item.tb = parseFloat(item.data) / parseFloat(item.dataSamePeriod) * 100 - 100;
                  }
                  item.fh = 1
                  if (item.tb < 0) {
                    item.tb = (0 - item.tb).toFixed(1)
                    item.fh = 2
                  } else {
                    item.tb = (item.tb).toFixed(1)
                    if (item.tb > 100) {
                      item.fh = 2
                    }
                  }
                } else {
                  item.tb = 0;
                }
                if (item.targetValue != null) {
                  let target = parseFloat(item.targetValue)
                  item.fh1 = 1
                  if (target < 0) {
                    target = 0 - target
                    item.fh1 = 2
                  }
                  console.log(target)
                  item.ysjd = (target * 100).toFixed(1)
                  item.ysjd = item.ysjd + '%'
                } else {
                  item.ysjd = 0;
                }
              }
            })

            that.taskList = listIn
          } else {
            that.taskList = []
          }
        }
      })
    },
    //
    toTaskList() {
      this.$emit("addCallbackTaskList", {formStatus:'taskList', item: this.item})
    },
    async handleClick(tab, event) {
      console.log(tab, event)
      await this.getMsgList()
    },
    handleClickA(tab, event) {
      console.log(tab, event)
    },

    getButtonPriviledge(){
      console.log('this.page',this.page)
      let menuId = this.page.id
      let me = this
      PermissionApi.queryButtonPriviledge(menuId,null).then(resp=>{
        PermissionApi.handleResponse(resp, me, function (data){
          me.buttonPriviledgeList = data.buttonPriviledges
          console.log('buttonPriviledgeList',me.buttonPriviledgeList)
        })
      })
    },
    _hasButtonPermission(name) {
      let buttonPriviledgeList = this.buttonPriviledgeList
      let hasButton = false
      for (let i = 0; i < buttonPriviledgeList.length; i++) {
        if (buttonPriviledgeList[i].name == name) {
          if (buttonPriviledgeList[i].hasPriviledge == 'Y') {
            return true
          } else {
            return false
          }
        }
      }
      return false
    }
  }
}
</script>

<style scoped>
#menu_963 .active-tab-view{
  overflow: hidden !important;
}
.active-tab-view {
  overflow: hidden !important;
}
.f-z17 {
  font-size: 16px;
}
.f-z16 {
  font-size: 15px;
}
.f-z15 {
  font-size: 14px;
  font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,apple color emoji,segoe ui emoji,Segoe UI Symbol,noto color emoji;
}
.f-z14 {
  font-size: 13px;
  font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,apple color emoji,segoe ui emoji,Segoe UI Symbol,noto color emoji;
  text-align: left;
}
.lh40 {
  line-height: 40px;
  padding: 10px 0px;
}
.text-gradient {
  background-image: linear-gradient(to right, #8f8f8f, #595959);
  -webkit-background-clip: text;
  color: transparent;
  font-size: 16px;
}
.text-gradient1 {
  background-image: linear-gradient(to right, #ffd666, #ad6800);
  -webkit-background-clip: text;
  color: transparent;
}
.text-gradient2 {
  background-image: linear-gradient(to right, #8f8f8f, #262626);
  -webkit-background-clip: text;
  color: transparent;
}
.text-gradient3 {
  background-image: linear-gradient(to right, #ffec3d, #d4b106);
  -webkit-background-clip: text;
  color: transparent;
}

.active {
  color: #409EFF;
  border-bottom: 2px solid #409EFF;
}

.text-gradient4 {
  background-image: linear-gradient(to right, #E6450F, #FFCB33);
  -webkit-background-clip: text;
  color: transparent;
}

</style>